import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
  BookOpen, Users, Award, CheckCircle, 
  ArrowRight, Shield, Clock, Zap 
} from 'lucide-react';

const Landing = () => {
  const { user } = useAuth();
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <header className="bg-gradient" style={{ color: 'white' }}>
        <div className="container py-4">
          <nav className="flex items-center justify-between">
            <div className="flex items-center"
              style={{
                gap: '12px',
                padding: '10px 18px',
                borderRadius: '999px',
                background: 'rgba(255,255,255,0.12)',
                backdropFilter: 'blur(4px)'
              }}>
              <BookOpen size={32} />
              <span style={{ fontSize: '1.25rem', fontWeight: 700 }}>KTB Eğitim Platformu</span>
            </div>
            <div className="flex items-center gap-3">
              {user ? (
                <>
                  <span style={{ fontWeight: 600 }}>{user.name}</span>
                  <Link
  to="/profile"
  className="btn"
  style={{
    backgroundColor: 'white',
    color: '#C62828',
    padding: '12px 26px',
    minWidth: '130px',
    borderRadius: '12px',
    fontWeight: 600,
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)'
  }}
>
                    Panelim
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/login" className="btn btn-outline" style={{ borderColor: 'white', color: 'white' }}>
                    Giriş Yap
                  </Link>
                  <Link to="/register" className="btn" style={{ backgroundColor: 'white', color: '#C62828' }}>
                    Başla
                  </Link>
                </>
              )}
            </div>
          </nav>
        </div>

        
<div className="container py-16" style={{ textAlign: 'center' }}>

  

  <img src="/assets/ktb-logo-red.png" alt="KTB Logo" style={{ width: "320px", maxWidth: "90%", display: "block", margin: "0 auto 30px auto", filter: "brightness(0) invert(1)" }} />

<h1
    style={{
      fontSize: '3rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      lineHeight: 1.2,
      whiteSpace: 'nowrap'
    }}
  >
    Bilgi Güvenliği Farkındalık Eğitimi
  </h1>

  <p
    style={{
      fontSize: '1.25rem',
      opacity: 0.9,
      maxWidth: '600px',
      margin: '0 auto 2rem'
    }}
  >
    Kültür ve Turizm Bakanlığı personeline yönelik hazırlanmış bilgi güvenliği
    farkındalık eğitimi. Bilgi güvenliği farkındalığını artırın ve eğitimi
    başarıyla tamamlayarak sertifikanızı alın.
  </p>

 
         
          <div className="flex items-center justify-center gap-4">
            {user ? (
              <>
                <Link to="/profile" className="btn btn-lg" style={{ backgroundColor: 'white', color: '#C62828' }}>
                  Eğitimlerim <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
                </Link>
              </>
            ) : (
              <>
                <Link to="/register" className="btn btn-lg" style={{ backgroundColor: 'white', color: '#C62828' }}>
                  Eğitime Başla <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
                </Link>
                <Link to="/login" className="btn btn-lg btn-outline" style={{ borderColor: 'white', color: 'white' }}>
                  Giriş Yap
                </Link>
              </>
            )}
          </div>

          <div
  className="flex items-center justify-center mt-8"
  style={{
    opacity: 0.95,
    gap: '56px',
    flexWrap: 'wrap'
  }}
>
            <div className="flex items-center"
              style={{
                gap: '12px',
                padding: '10px 18px',
                borderRadius: '999px',
                background: 'rgba(255,255,255,0.12)',
                backdropFilter: 'blur(4px)'
              }}>
              <CheckCircle size={20} />
              <span>KTB Personeline Özel</span>
            </div>
            <div className="flex items-center"
              style={{
                gap: '12px',
                padding: '10px 18px',
                borderRadius: '999px',
                background: 'rgba(255,255,255,0.12)',
                backdropFilter: 'blur(4px)'
              }}>
              <CheckCircle size={20} />
              <span>Sertifikalı Eğitim</span>
            </div>
            <div className="flex items-center"
              style={{
                gap: '12px',
                padding: '10px 18px',
                borderRadius: '999px',
                background: 'rgba(255,255,255,0.12)',
                backdropFilter: 'blur(4px)'
              }}>
              <CheckCircle size={20} />
              <span>Esnek Öğrenme</span>
            </div>
          </div>
        </div>
      </header>

      {/* Features Section */}
      <section className="py-16" style={{ backgroundColor: 'white' }}>
        <div className="container">
          <h2 className="text-center text-2xl font-bold mb-2">Neden Bu Platform?</h2>
          <p className="text-center text-gray mb-8">Bilgi güvenliği farkındalığı için ihtiyacınız olan her şey</p>

          <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
            <div className="card p-6 text-center">
              <div className="flex items-center justify-center mb-4">
                <div style={{ 
                  width: '60px', 
                  height: '60px', 
                  borderRadius: '12px', 
                  backgroundColor: '#e0f2fe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <BookOpen size={28} color="#C62828" />
                </div>
              </div>
              <h3 className="font-semibold text-lg mb-2">Etkileşimli Eğitimler</h3>
              <p className="text-gray text-sm">
                Bilgi güvenliği farkındalığını artırmaya yönelik etkileşimli eğitim içerikleri.
              </p>
            </div>

            <div className="card p-6 text-center">
              <div className="flex items-center justify-center mb-4">
                <div style={{ 
                  width: '60px', 
                  height: '60px', 
                  borderRadius: '12px', 
                  backgroundColor: '#d1fae5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Clock size={28} color="#059669" />
                </div>
              </div>
              <h3 className="font-semibold text-lg mb-2">Kendi Hızınızda Öğrenin</h3>
              <p className="text-gray text-sm">
                İlerlemeniz otomatik olarak kaydedilir ve kaldığınız yerden devam edebilirsiniz.
              </p>
            </div>

            <div className="card p-6 text-center">
              <div className="flex items-center justify-center mb-4">
                <div style={{ 
                  width: '60px', 
                  height: '60px', 
                  borderRadius: '12px', 
                  backgroundColor: '#fef3c7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Award size={28} color="#d97706" />
                </div>
              </div>
              <h3 className="font-semibold text-lg mb-2">Sertifika Kazanın</h3>
              <p className="text-gray text-sm">
                Eğitimi tamamladığınızda doğrulanabilir dijital sertifika oluşturulur.
              </p>
            </div>

            <div className="card p-6 text-center">
              <div className="flex items-center justify-center mb-4">
                <div style={{ 
                  width: '60px', 
                  height: '60px', 
                  borderRadius: '12px', 
                  backgroundColor: '#fee2e2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Shield size={28} color="#dc2626" />
                </div>
              </div>
              <h3 className="font-semibold text-lg mb-2">Güvenli ve Gizli</h3>
              <p className="text-gray text-sm">
                Platform yalnızca yetkili personelin kullanımına açıktır.
              </p>
            </div>

            <div className="card p-6 text-center">
              <div className="flex items-center justify-center mb-4">
                <div style={{ 
                  width: '60px', 
                  height: '60px', 
                  borderRadius: '12px', 
                  backgroundColor: '#ede9fe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Zap size={28} color="#7c3aed" />
                </div>
              </div>
              <h3 className="font-semibold text-lg mb-2">İlerlemeyi Takip Edin</h3>
              <p className="text-gray text-sm">
                Eğitim ilerlemenizi ve başarı durumunuzu takip edebilirsiniz.
              </p>
            </div>

            <div className="card p-6 text-center">
              <div className="flex items-center justify-center mb-4">
                <div style={{ 
                  width: '60px', 
                  height: '60px', 
                  borderRadius: '12px', 
                  backgroundColor: '#fce7f3',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Users size={28} color="#db2777" />
                </div>
              </div>
              <h3 className="font-semibold text-lg mb-2">Kurumsal Giriş</h3>
              <p className="text-gray text-sm">
                Kurumsal Microsoft hesabınız ile güvenli ve hızlı şekilde giriş yapabilirsiniz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Course Preview */}
      <section className="py-16" style={{ backgroundColor: '#f8fafc' }}>
        <div className="container">
          <div className="flex items-center gap-8" style={{ flexWrap: 'wrap' }}>
            <div style={{ flex: '1', minWidth: '300px' }}>
              <span className="badge badge-info mb-3">Öne Çıkan Eğitim</span>
              <h2 className="text-2xl font-bold mb-4">Bilgi Güvenliği Farkındalık Eğitimi</h2>
              <p className="text-gray mb-6">
                Kültür ve Turizm Bakanlığı personeline yönelik hazırlanan Bilgi Güvenliği Farkındalık Eğitimi. Siber güvenlik riskleri, 
                veri koruma prensipleri, güvenli internet kullanımı, kimlik avı saldırıları ve kurumsal güvenlik politikaları konularında farkındalık kazanarak güvenli dijital çalışma alışkanlıkları edinin.
              </p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {[
                  'Etkileşimli eğitim içerikleri',
                  'Kendi hızında öğrenme',
                  'İlerleme takibi',
                  'Tamamlama sertifikası'
                ].map((item, index) => (
                  <li key={index} className="flex items-center gap-2 mb-2">
                    <CheckCircle size={18} color="#059669" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/register" className="btn btn-primary btn-lg mt-4">
                Hemen Başla <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
              </Link>
            </div>
            <div style={{ flex: '1', minWidth: '300px' }}>
              <div className="card" style={{ padding: '2rem' }}>
                <div style={{ 
                  aspectRatio: '16/9', 
                  backgroundColor: '#e2e8f0', 
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  


<img
  src="/assets/cyberattack-amico.png"
  alt="Bilgi Güvenliği"
  style={{
    maxWidth: '100%',
    maxHeight: '350px'
  }}
/>



                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient" style={{ color: 'white', textAlign: 'center' }}>
        <div className="container">
          <h2 className="text-2xl font-bold mb-4">Bilgi Güvenliği Eğitimine Hazır mısınız?</h2>
          <p style={{ opacity: 0.9, marginBottom: '2rem', maxWidth: '500px', margin: '0 auto 2rem' }}>
            Bilgi güvenliği farkındalık eğitimine katılın ve sertifikanızı alın.
          </p>
          <Link to="/register" className="btn btn-lg" style={{ backgroundColor: 'white', color: '#C62828' }}>
            Hesap Oluştur
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: '#1e293b', color: 'white', padding: '2rem 0' }}>
        <div className="container">
          <div className="flex items-center justify-between" style={{ flexWrap: 'wrap', gap: '1rem' }}>
            <div className="flex items-center"
              style={{
                gap: '12px',
                padding: '10px 18px',
                borderRadius: '999px',
                background: 'rgba(255,255,255,0.12)',
                backdropFilter: 'blur(4px)'
              }}>
              <BookOpen size={24} />
              <span className="font-semibold">KTB Eğitim Platformu</span>
            </div>
            <p style={{ opacity: 0.7, fontSize: '0.875rem' }}>
              © {new Date().getFullYear()} T.C. Kültür ve Turizm Bakanlığı
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
